Vue.component('catalog-filter', {
    methods: {
        changeSort(event) {
            this.redirectTo(event.target.value);
        },
        redirectTo(address) {
            window.location.href = address;
        }
    }
});